var React = require('react');

function TaskDrawReact (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"136.78","y1":"92.25","x2":"268.51","y2":"138.24","key":0}),React.createElement("circle",{"cx":"101.92","cy":"78.88","r":"32.85","key":1}),React.createElement("circle",{"cx":"304.37","cy":"149.81","r":"34","key":2}),React.createElement("circle",{"cx":"222.56","cy":"319.64","r":"34.02","key":3}),React.createElement("line",{"x1":"288.08","y1":"183.61","x2":"238.72","y2":"286.1","key":4}),React.createElement("line",{"x1":"365.73","y1":"402.42","x2":"255.06","y2":"338.46","key":5}),React.createElement("circle",{"cx":"398.08","cy":"421.12","r":"33.37","key":6})]);
}

TaskDrawReact.defaultProps = {"viewBox":"0 0 500 500"};

module.exports = TaskDrawReact;

TaskDrawReact.default = TaskDrawReact;
